<template>
    <div v-if="!loading">
        <div :class="containerClass" v-if="!banners.length && defaultBanner">
            <a :href="defaultBanner.url" :title="defaultBanner.title">
                <img :src="defaultBanner.image" style="width:100%;max-width:100%;" :title="defaultBanner.title" />
            </a>
        </div>
        <div :class="containerClass" v-if="banners.length">
            <template v-if="banners.length == 1">
                <figure v-for="(banner, index) in banners" :key="index" >
                    <a v-if="getBannerUrl(banner)" :href="getBannerUrl(banner)" :title="getBannerCaption(banner)">
                        <img :srcset="getSrcSet(banner)" :sizes="getSizes(banner)" class="slide-image" :class="imageClass" :alt="getBannerCaption(banner)" />
                    </a>
                    <img :srcset="getSrcSet(banner)" :sizes="getSizes(banner)" class="slide-image" :class="imageClass" :alt="getBannerCaption(banner)" v-else />
                </figure>
            </template>
            <template v-else>
            <carousel :pagination-enabled="false" :perPage="1" :autoplay="true" :loop="true">
                <slide v-for="(banner, index) in banners" :key="index">
                    <div>
                         <a v-if="getBannerUrl(banner)" :href="getBannerUrl(banner)" :title="getBannerCaption(banner)">
                            <img :srcset="getSrcSet(banner)" :sizes="getSizes(banner)" class="slide-image" :alt="getBannerCaption(banner)" />
                        </a>
                        <img :srcset="getSrcSet(banner)" :sizes="getSizes(banner)" class="slide-image" :alt="getBannerCaption(banner)" v-else />
                    </div>
                </slide>
            </carousel>
            </template>
        </div>
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';
    import Banners from '../Services/Banners.js'

    export default {
        components: {
           Carousel,
           Slide
        },
        props: {
            imageClass: {
                type: String,
                default: null,
            },
            containerClass: {
                type: String,
                default: null,
            },
            defaultBanner: {
                type: Object,
                default: null,
            },
            handle: {
                type: String,
            },
            handles: {
                type: String
            },
            modelId: {
                type: String,
                default: null
            },
            limit: {
                type: Number,
                default: null
            },
            random: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                loading: true,
                banners: []
            }
        },
        methods: {
            getBannerUrl (banner) {
                const bannerWithUrl = _.find(banner, b => b.url)
                return bannerWithUrl ? bannerWithUrl.url : null
            },
            getBannerCaption (banner) {
                const bannerWithCaption = _.find(banner, b => b.caption)
                return bannerWithCaption ? bannerWithCaption.url : null
            },
            getSizes (images) {
                const highToLow = _.orderBy(images, img => {
                    return parseInt(img.breakpoint.data.image_width)
                }, 'desc')
                return _.map(highToLow, img => {
                    const screenWidth = img.breakpoint.data.screen_width
                    return `(min-width: ${screenWidth}px) ${Math.round((screenWidth / '1200' || 1) * 100)}vw`
                }).join(', ')
            },
            getSrcSet(images) {
                const filtered = _.filter(images, image => {
                    return image.asset.data
                })
                const highToLow = _.orderBy(filtered, img => {
                    return parseInt(img.breakpoint.data.image_width)
                }, 'desc')
                return _.map(highToLow, img => {
                    return `${img.asset.data.url} ${img.breakpoint.data.image_width.trim()}w`
                }).join(', ')
            }
        },
        async mounted () {
            const slides = await Banners.get(this.handle, this.handles, {
                model_id: this.modelId,
                limit: this.limit,
                random: this.random
            })
            const assets = _.map(slides.data, slide => {
                return slide.assets.data
            })
            this.banners = assets
            this.loading = false
        }
    }
</script>

<style>
    .slide-image {
        max-width:100%;
        width:100%;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/SiteBanners.vue